import { convertTimestampToDate } from '@travelity/api/services';
import { differenceInMinutes } from 'date-fns';

export const getEventDurationLabel = (startTs?: number, endTs?: number) => {
    if (!startTs || !endTs) return '0:00';

    const start = convertTimestampToDate(startTs);
    const end = convertTimestampToDate(endTs);

    const totalMinutes = Math.max(0, differenceInMinutes(end, start));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0) return `${minutes}m`;
    if (hours >= 24) return `${Math.floor(hours / 24)}d ${hours % 24}h`;

    return `${hours}h ${String(minutes).padStart(2, '0')}m`;
};
